import { useDispatch } from 'react-redux';
import { Box, Text } from '@quintoandar-tokko/jopijs';
import PropertyData from '../PendingEvents/PropertyData';
import TimeStatusIndicator from '../TimeStatusIndicator';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';
import { PENDING_REVIEW_VIEW } from '../../constants';
import { getPendingReviewDisplayTime } from './utils';
import { TRACK_ELEMENT } from '../../constants/track';
import { showQuickDisplay } from '@/store/slices/components/quickDisplay/QuickDisplaySlice';
import styles from './pendingReview.module.scss';

function PendingReviewRow({
  item,
  viewMode,
  entityType = 'property',
  onClick,
  trackCallback = null,
}) {
  const dispatch = useDispatch();
  const todayLabel = Trans(translations, 'Today');
  const displayTime = getPendingReviewDisplayTime(item, todayLabel);
  const showChangesCount = viewMode === PENDING_REVIEW_VIEW.MODIFIED;
  const changesCount = Number(item.changesCount) || 0;
  const changesCountLabel =
    changesCount === 1
      ? Trans(translations, 'PendingReviewOneChange')
      : Trans(translations, 'PendingReviewChangesCount', String(changesCount));

  const timeTooltip = Trans(translations, 'PendingReviewSent');

  const handleClick = () => {
    if (onClick) {
      onClick(item);
    }

    if (trackCallback) {
      trackCallback(TRACK_ELEMENT.ROW);
    }
  };

  const handleQuickDisplayOpen = (event) => {
    event.stopPropagation();

    if (item?.id == null) {
      return;
    }

    dispatch(
      showQuickDisplay({
        id: item.id,
        development: entityType === 'development',
      })
    );

    if (trackCallback) {
      trackCallback(TRACK_ELEMENT.PROPERTY_ADDRESS);
    }
  };

  return (
    <Box className={styles.row} onClick={handleClick}>
      <Box className={styles.propertyData}>
        <Box
          className={styles.propertyDataTarget}
          onClick={handleQuickDisplayOpen}
        >
          <PropertyData
            picture={item.picture}
            address={item.address}
            location={item.location}
            entityType={entityType}
            showDevelopmentIcon={entityType === 'development'}
          />
        </Box>
      </Box>
      {showChangesCount && (
        <Text className={styles.changesCount}>{changesCountLabel}</Text>
      )}
      <Box className={styles.timeStatus}>
        <TimeStatusIndicator
          displayTime={displayTime}
          toolTipText={timeTooltip}
          value={item.daysPending}
          alertOnExceed={false}
          threshold={0}
        />
      </Box>
    </Box>
  );
}

export default PendingReviewRow;
